import React, { ComponentClass } from 'react';
import errorBoundary from 'presentation/hocs/errorBoundary';
import visibilitySet from 'presentation/hocs/visibilitySet';
import { Container, Row, Column, Justify } from '@uds/grid';
import { useTheme } from '@uds/theme-utils';
import { useBreakpoints } from '@uds/responsive';
import { bootstrapResponsiveColumns } from 'presentation/utils/responsiveColumns';
import { RibbonProps, Type } from 'domain/constants/ribbons';
import { Product } from '@uds/product';
import { PricingStrategy } from 'presentation/components/common/ProductPrice/constants';
import ribbonPadding from 'presentation/utils/ribbonPadding';

import CardTag from './CardTag';
import Ribbon from '../Ribbon';
import { SavingType } from './CardLink';

type DomainType = {
  product: Product;
  pricingStrategy: PricingStrategy;
  saving: SavingType;
  badge: string;
  url: string;
};
interface OuterProps extends RibbonProps {
  domains: Array<DomainType>;
}

const PureDomainPromo = ({ id, loading, colorway, layout, hBaseline = 1, name, domains = [] }: OuterProps) => {
  // Adding index to domais array to avoid performance issues when passing keys as index to render
  const domainsWithIndex = domains.map((item, index) => ({
    ...item,
    index: `DomainPromo${index}${id}`,
  }));

  const { isMinSm, isMinLg } = useBreakpoints();
  // @ts-ignore: error after upgrading to ux-configs
  const columnSize = bootstrapResponsiveColumns([1, 2, 3], layout.columns);
  const {
    theme: { spacing },
  } = useTheme();

  return (
    <Ribbon id={id} name={name} layout={layout} colorway={colorway} loading={loading} type={Type.DOMAIN_PROMO}>
      <div style={ribbonPadding({ spacing, layout, isMinLg, isMinSm, linariaPadding: true })}>
        <Container>
          <Row vblock={true} justify={Justify.FLEX_START}>
            {domainsWithIndex.map((domain) => (
              <Column key={domain.index} xs={columnSize[0]} sm={columnSize[1]} lg={columnSize[2]}>
                <CardTag
                  {...domain}
                  product={domain.product}
                  layout={layout}
                  pricingStrategy={domain.pricingStrategy}
                  hBaseline={hBaseline}
                  colorway={colorway}
                />
              </Column>
            ))}
          </Row>
        </Container>
      </div>
    </Ribbon>
  );
};

PureDomainPromo.displayName = 'DomainPromo';

export default errorBoundary(visibilitySet(PureDomainPromo)) as ComponentClass<OuterProps>;
